module.exports = __webpack_public_path__ + "img/blog-placeholder.0c1eee28.png";